import React, { useState } from "react";
import {
  Box,
  Popover,
  useTheme,
  TextField,
} from "@mui/material";

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
  disabled?: boolean;
  mb?: number;
}

// Default color for new instances
const DEFAULT_COLOR = "#1553CA";

const ColorPicker: React.FC<ColorPickerProps> = ({
  value = DEFAULT_COLOR,
  onChange,
  label,
  disabled = false,
  mb = 4,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const handleCustomColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    if (color.match(/^#[0-9A-Fa-f]{6}$/)) {
      onChange(color);
    }
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ mb: mb }}>
      <Box
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          p: 1,
          backgroundColor: "#F5F5F5",
          borderRadius: 2,
          border: "1px solid #E0E0E0",
          cursor: disabled ? "not-allowed" : "pointer",
          "&:hover": {
            backgroundColor: disabled ? "#F5F5F5" : "#EEEEEE",
          },
          "&:disabled": {
            opacity: 0.6,
          },
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            backgroundColor: value,
            borderRadius: 1,
            border: "1px solid #E0E0E0",
            flexShrink: 0,
          }}
        />
        <Box
          sx={{
            fontSize: "0.875rem",
            fontWeight: 500,
            color: theme.palette.text.primary,
            flexGrow: 1,
            textAlign: "left",
          }}
        >
          {value}
        </Box>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          // maxWidth: "200px",
        }}
      >
        <Box sx={{ p: 2, minWidth: 200 }}>
          <TextField
            type="color"
            value={value}
            onChange={handleCustomColorChange}
            size="small"
            fullWidth
            label="Choose Color"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
              },
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};

export default ColorPicker;
